<template>
  <div class="row">
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="isShow"
      width="539px"
      height="500px"
      style="margin: 0 auto;"
      class="todo-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="handleSave">
        <div class="row">
          <div class="col-12 investor-table-wrapper">
            <div class="row">
              <!-- <div class="col-12"> -->
              <div class="col-12">
                <div>
                  Task:
                  <span class="required">*</span>
                </div>
                <!-- <input
                  type="text"
                  v-model="value.data.title"
                  class="todo-form form-control"
                  style="width: 100%;"
                  required
                  placeholder="Task"
                />-->
                <fieldset
                  data-concat-into="concatinated"
                  class="todo-form-fieldSet todo-form form-control"
                >
                  <div>
                    <input
                      type="text"
                      v-model="value.data.title"
                      required
                      placeholder="Title"
                      class="todo-form-fieldSet-input"
                    />
                    <!-- </div> -->
                    <hr
                      style="color:#707070;
                              margin-top: 0.5rem !important;
                              margin-bottom: 0.5rem !important;"
                    />
                    <!-- <div> -->
                    <textarea
                      placeholder="Description"
                      required="required"
                      rows="4"
                      cols="50"
                      class="todo-form-fieldSet-textArea form-control"
                      v-model="value.data.description"
                    ></textarea>
                  </div>
                </fieldset>
              </div>
              <!-- <div class="col-6">
              <div>
                Task Type:
                <span class="required">*</span>
              </div>
              <el-select
                class="select-primary"
                size="large"
                placeholder="Select Task type"
                v-model="value.data.task_type"
              >
                <el-option
                  v-for="item in taskTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              </div>-->
            </div>

            <div class="row">
              <div class="col-6">
                <div>
                  Priority:
                  <span class="required">*</span>
                </div>
                <el-select
                  class="todo-dropdown-el-select"
                  size="large"
                  required
                  placeholder="Select priority"
                  v-model="value.data.priority"
                  @change="handleDueDate(value.data.priority)"
                >
                  <el-option
                    v-for="item in vals.PRIORITY_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-6">
                <div>Action Type:</div>
                <el-select
                  class="todo-dropdown-el-select"
                  size="large"
                  placeholder="Select Action type"
                  v-model="value.data.action_type"
                >
                  <el-option
                    v-for="item in vals.ACTION_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <div>Due Date:</div>
                <input
                  class="todo-form-date todo-form form-control"
                  type="date"
                  v-if="value.isCreate"
                  :min="moment().format('YYYY-MM-DD')"
                  :value="value.data.due_date && moment.utc(value.data.due_date).format('YYYY-MM-DD')?moment.utc(value.data.due_date).format('YYYY-MM-DD'):moment.utc(new Date()).format('YYYY-MM-DD')"
                  @input="value.data.due_date = moment($event.target.valueAsDate)"
                />
                <input
                  class="todo-form-date todo-form form-control"
                  type="date"
                  v-if="!value.isCreate"
                  :value="value.data.due_date && moment.utc(value.data.due_date).format('YYYY-MM-DD')?moment.utc(value.data.due_date).format('YYYY-MM-DD'):moment.utc(new Date()).format('YYYY-MM-DD')"
                  @input="value.data.due_date = moment($event.target.valueAsDate)"
                />
              </div>
              <div class="col-6">
                <div>Remind On:</div>
                <input
                  class="todo-form-date todo-form form-control"
                  type="date"
                  v-if="value.isCreate"
                  :min="moment().format('YYYY-MM-DD')"
                  :value="value.data.remind_on && moment.utc(value.data.remind_on).format('YYYY-MM-DD')?moment.utc(value.data.remind_on).format('YYYY-MM-DD'):''"
                  @input="value.data.remind_on = moment($event.target.valueAsDate)"
                />
                <input
                  class="todo-form-date todo-form form-control"
                  type="date"
                  v-if="!value.isCreate"
                  :value="value.data.remind_on && moment.utc(value.data.remind_on).format('YYYY-MM-DD')?moment.utc(value.data.remind_on).format('YYYY-MM-DD'):''"
                  @input="value.data.remind_on = moment($event.target.valueAsDate)"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div style="margin-bottom: 4px;">Assignee:</div>
                <multiselect
                  v-model="tagValue"
                  :options="userDataList"
                  :multiple="true"
                  track-by="account_id"
                  :custom-label="customLabel"
                  placeholder="Select Assignee"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 d-flex" style="padding-top:1.5rem !important">
            <span class="required pt-2">* Indicates a required field</span>
            <div class="col-xl edit-company-action-button-row" style="padding: 0px;margin-top:0px">
              <button
                type="button"
                class="todo-form-cancel-button btn-outline-secondary"
                @click.prevent="handleCancel"
              >Cancel</button>
              <button
                type="submit"
                :disabled="isSaving"
                class="todo-form-submit-button btn btn-primary"
              >
                <!-- {{SubmitButtonTitle}} -->
                Save
                <!-- <i class="nc-icon nc-refresh-02 spinner" v-if="isSaving"></i> -->
                <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
              </button>
            </div>
          </div>
        </div>
      </form>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import swal from "sweetalert2";
import { vals } from "../../../util";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import todo from "../../../store/modules/todo";
export default {
  name: "dialogtodo",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    Multiselect,
  },
  props: {
    value: {
      isShow: Boolean,
      isCreate: Boolean,
      data: Object,
      assigned_to: Array,
    },
  },
  watch: {
    valueAssignedTo: {
      handler: function (nData) {
        let userList = JSON.parse(JSON.stringify(this.userDataList));
        let arr = [];
        nData.map((item) => {
          userList.find((data) => {
            if (item == data.account_id) {
              arr.push(data);
              return;
            }
          });
        });
        this.tagValue = arr;
      },
    },
  },
  computed: {
    ...mapGetters("todo", ["current_component", "context", "showModal"]),
    ...mapGetters("user", ["user"]),
    moment() {
      return moment;
    },
    userDataList() {
      if (this.context && this.context == "tax_session_todo") {
        let userList = [
          {
            account_id: this.user.id ? this.user.id : "",
            name: "Me",
          },
        ];
        return userList;
      } else {
        let getAllUsers = this.$store.getters["team/getAllUsers"];
        let userList = getAllUsers
          ? JSON.parse(JSON.stringify(getAllUsers))
          : [];
        if (userList && userList.length > 0) {
          userList.map((item) => {
            item.account_id = item.account._id;
            if (item.account.firstName != item.account.lastName)
              item.name = `${item.account.firstName} ${item.account.lastName}`;
            else item.name = item.account.firstName || item.account.lastName;
          });
          let index = userList.findIndex((item) =>
            item.account && item.account._id
              ? item.account._id == this.$route.params.account_id
              : -1
          );
          if (index >= 0) userList[index].name = "Me";
        }
        return userList;
      }
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.value.data.priority = "medium";
        this.$emit("input", this.value);
      },
    },
    isCreate: {
      get() {
        return this.value.isCreate;
      },
      set(value) {
        this.value.isCreate = value;
      },
    },
    title: {
      get() {
        // return this.value.isCreate ? "Add To-do" : "Edit To-do";
        return this.value.isCreate ? "Create New Task" : "Task Details";
      },
    },
    SubmitButtonTitle: {
      get() {
        return this.value.isCreate ? "Create Task" : "Update Task";
      },
    },
    valueAssignedTo() {
      this.value.assigned_to =
        typeof this.value.assigned_to == "string"
          ? [this.value.assigned_to]
          : this.value.assigned_to;
      //let assigned_to = JSON.parse(JSON.stringify(this.assigned_to));
      return this.value.assigned_to;
    },
  },
  data() {
    return {
      vals,
      isSaving: false,
      tagValue: [],
      todoContext: "",
    };
  },
  methods: {
    customLabel(option) {
      return `${option.name}`;
    },
    handleCancel() {
      this.isSaving = false;
      this.isShow = false;
      this.$store.commit("todo/setNotificationTodo", {
        context: "",
        showModal: false,
      });
    },
    handleSave() {
      // this.isSaving = true;
      let self = this;
      let route = this.$route.path.split("/");
      this.value.data.assigned_to = this.tagValue.map((item) => {
        return item.account_id;
      });
      this.value.data.task_type = "todo";
      this.value.data.urgency = 9;
      this.value.data.due_date = this.value.data.due_date
        ? this.value.data.due_date
        : moment.utc(new Date()).format("YYYY-MM-DD");
      if (this.isCreate == true) {
        this.value.data.workspace = this.$route.params.workspace_id;
        this.value.data.component = this.current_component;
        if (
          !this.value.data.description ||
          !this.value.data.priority ||
          !this.value.data.component ||
          !this.value.data.task_type ||
          !this.value.data.title
        ) {
          let html = `There were validation errors with your To-do information:\n`;
          let validationFields = "";
          if (!this.value.data.description) {
            validationFields += "Description,";
          }
          if (!this.value.data.priority) {
            validationFields += "Priority,";
          }
          if (!this.value.data.component) {
            validationFields += "Component,";
          }
          if (!this.value.data.task_type) {
            validationFields += "Task Type,";
          }
          if (!this.value.data.title) {
            validationFields += "Title,";
          }
          validationFields = validationFields.substring(
            0,
            validationFields.length - 1
          );
          html += `Missing required fields:${validationFields}`;
          alert(html);
        } else {
          this.isSaving = true;
          let url = "";
          if (this.context == "tax_session_todo") url = "todo/apiPostTaxTodo";
          else url = "todo/apipostTodo";
          this.$store
            .dispatch(url, this.value.data)
            .then((data) => {
              this.$store.dispatch(
                "todo/getAllTodos",
                this.$route.params.workspace_id
              );
              this.refreshTodos(this.current_component);
              if (
                self.value.data.assigned_to &&
                self.value.data.assigned_to.length > 0
              ) {
                let accountIds = self.value.data.assigned_to.filter(
                  (item) => item != self.$route.params.account_id
                );
                if (accountIds && accountIds.length > 0) {
                  let userName = self.$store.getters["user/user"];
                  let userNameString =
                    userName.firstName != userName.lastName
                      ? `${userName.firstName} ${userName.lastName} `
                      : userName.lastName;
                  accountIds.map((item) => {
                    let payloadObj = {};
                    payloadObj.account = item;
                    payloadObj.workspace = self.$route.params.workspace_id;
                    payloadObj.title = "Todo";
                    payloadObj.body = `${userNameString} has assigned to-do to you. Click on this notification to view.`;
                    payloadObj.link = `/${payloadObj.account}/${payloadObj.workspace}/todos?id=${data.data.encrypt.success[0]._id}`;
                    payloadObj.type = "Task";
                    payloadObj.entityType = "Todo";
                    payloadObj.entityId = data.data.encrypt.success[0]._id;
                    payloadObj.notified_by = self.$route.params.account_id;
                    self.$store
                      .dispatch(
                        "notifications/apiPostGenericNotification",
                        payloadObj
                      )
                      .then((notificationData) => {})
                      .catch((err) => {});
                  });
                }
              }
            })
            .catch((error) => {
              this.$toaster.error("Fail to Create a To-do..!!");
              this.isSaving = false;
            });
        }
      } else {
        if (
          !this.value.data.description ||
          !this.value.data.priority ||
          !this.value.data.component ||
          !this.value.data.task_type ||
          !this.value.data.title
        ) {
          let html = `There were validation errors with your To-do information:\n`;
          let validationFields = "";
          if (!this.value.data.description) {
            validationFields += "Description,";
          }
          if (!this.value.data.priority) {
            validationFields += "Priority,";
          }
          if (!this.value.data.component) {
            validationFields += "Component,";
          }
          if (!this.value.data.task_type) {
            validationFields += "Task Type,";
          }
          if (!this.value.data.title) {
            validationFields += "Title,";
          }
          validationFields = validationFields.substring(
            0,
            validationFields.length - 1
          );
          html += `Missing required fields:${validationFields}`;
          alert(html);
        } else {
          this.isSaving = true;
          return api
            .patch("/todo", {
              encrypt: {
                data: {
                  todo: this.value.data,
                },
              },
            })
            .then((data) => {
              // this.$store.commit(
              //   "todo/EditTodoData",
              //   data.data.encrypt.success[0]
              // );
              //this.refreshTodos(route[3]);
              this.$store.dispatch(
                "todo/getAllTodos",
                this.$route.params.workspace_id
              );
              //this.$store.dispatch("todo/stop");

              if (window.sessionStorage.getItem("todoAssignes")) {
                let todoAssignes = JSON.parse(
                  window.sessionStorage.getItem("todoAssignes")
                );
                if (window.sessionStorage.getItem("todoData")) {
                  self.createDuePriorityNotification(
                    self.value.data,
                    todoAssignes
                  );
                }
                window.sessionStorage.removeItem("todoAssignes");
                let givenAssignes = self.value.data.assigned_to;
                givenAssignes.map((item) => {
                  let index = todoAssignes.findIndex(
                    (assignId) =>
                      assignId == item && item != self.$route.params.account_id
                  );
                  if (index < 0) {
                    let userName = self.$store.getters["user/user"];
                    let userNameString =
                      userName.firstName != userName.lastName
                        ? `${userName.firstName} ${userName.lastName} `
                        : userName.lastName;
                    let payloadObj = {};
                    payloadObj.account = item;
                    payloadObj.workspace = self.$route.params.workspace_id;
                    payloadObj.title = "Todo";
                    payloadObj.body = `${userNameString} has assigned to-do to you. Click on this notification to view.`;
                    payloadObj.link = `/${payloadObj.account}/${payloadObj.workspace}/todos?id=${self.value.data._id}`;
                    payloadObj.type = "Task";
                    payloadObj.entityType = "Todo";
                    payloadObj.entityId = self.value.data._id;
                    payloadObj.notified_by = self.$route.params.account_id;
                    self.$store
                      .dispatch(
                        "notifications/apiPostGenericNotification",
                        payloadObj
                      )
                      .then((notificationData) => {})
                      .catch((err) => {});
                  }
                });
              }
              this.refreshTodos(this.current_component);
            })
            .catch((error) => {
              console.log("to-do edit error", error);
              this.isSaving = false;
            });
        }
      }
    },
    createDuePriorityNotification(data, assignees) {
      let self = this;
      let oldData = JSON.parse(window.sessionStorage.todoData);
      window.sessionStorage.removeItem("todoData");
      let givenAssignes = data.assigned_to;
      givenAssignes.map((item) => {
        let index = assignees.findIndex(
          (assignId) =>
            assignId == item && item != self.$route.params.account_id
        );
        if (index >= 0) {
          let userName = self.$store.getters["user/user"];
          let userNameString =
            userName.firstName != userName.lastName
              ? `${userName.firstName} ${userName.lastName} `
              : userName.lastName;
          let payloadObj = {};
          payloadObj.account = item;
          payloadObj.workspace = self.$route.params.workspace_id;
          payloadObj.title = "Todo";
          payloadObj.link = `/${payloadObj.account}/${payloadObj.workspace}/todos?id=${data._id}`;
          payloadObj.type = "Task";
          payloadObj.entityType = "Todo";
          payloadObj.entityId = data._id;
          payloadObj.notified_by = self.$route.params.account_id;
          if (
            moment(oldData.due_date).format("YYYY-MM-DD") !=
            moment(data.due_date).format("YYYY-MM-DD")
          ) {
            payloadObj.body = `${userNameString} has changed the due date of '${
              data.title
            }' to ${moment(data.due_date).format(
              "MM-DD-YYYY"
            )}. Click on this notification to view.`;
          } else if (
            oldData.priority.toLowerCase() != data.priority.toLowerCase()
          ) {
            payloadObj.body = `${userNameString} has changed the priority of '${
              data.title
            }' to ${
              data.priority.charAt(0).toUpperCase() + data.priority.slice(1)
            }. Click on this notification to view.`;
          }
          self.$store
            .dispatch("notifications/apiPostGenericNotification", payloadObj)
            .then((notificationData) => {})
            .catch((err) => {});
        }
      });
    },
    refreshTodos(component) {
      this.$store.getters["todo/componentTodos"](
        component,
        this.$route.params.workspace_id
      );
      if (this.current_component == "todo") {
        this.$emit("refresh");
      }
      if (this.context) {
        this.$store.commit("todo/setNotificationTodo", {
          context: "",
          showModal: false,
        });
      }
      this.$toaster.success("Saved successfully.");
      this.isSaving = false;
      this.isShow = false;
    },
    handleDueDate(priority) {
      if (priority == "low") {
        this.value.data.due_date = new Date().setDate(new Date().getDate() + 6);
      } else if (priority == "medium") {
        this.value.data.due_date = new Date().setDate(new Date().getDate() + 3);
      } else {
        this.value.data.due_date = new Date();
      }
    },
  },
  mounted() {
    this.value.assigned_to =
      typeof this.value.assigned_to == "string"
        ? [this.value.assigned_to]
        : this.value.assigned_to;
    let userList = JSON.parse(JSON.stringify(this.userDataList));
    let arr = [];
    this.value.assigned_to.map((item) => {
      userList.find((data) => {
        if (item == data.account_id) {
          arr.push(data);
          return;
        }
      });
    });
    this.tagValue = arr;
  },
};
</script>

<style>
input[type="date"] {
  position: relative;
}

/* create a new arrow, because we are going to mess up the native one
see "List of symbols" below if you want another, you could also try to add a font-awesome icon.. */
input[type="date"]:after {
  font-family: "Font Awesome 5 Free";
  font-weight: 400;
  content: "\f073";
  color: #838383;
  padding: 0 5px;
}

/* change color of symbol on hover */
input[type="date"]:hover:after {
  /* color: #bf1400; */
}

/* make the native arrow invisible and stretch it over the whole field so you can click anywhere in the input field to trigger the native datepicker*/
input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  color: transparent;
  background: transparent;
}

/* adjust increase/decrease button */
input[type="date"]::-webkit-inner-spin-button {
  z-index: 1;
}

/* adjust clear button */
input[type="date"]::-webkit-clear-button {
  z-index: 1;
}

.multiselect__tag {
  color: #fff !important;
  background: #afafaf !important;
}

.multiselect__tags {
  border: 1px solid #707070 !important;
  background: #fff;
}

.multiselect__option--highlight {
  background: none !important;
  outline: none;
  color: #000 !important;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: none !important;
  color: #000 !important;
}

.multiselect__tag-icon:after {
  content: "\D7";
  color: #fff !important;
  font-size: 14px;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: none !important;
  color: #fff !important;
}
.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: #fff !important;
}
.multiselect__option--highlight:after {
  content: attr(data-select);
  background: none !important;
  color: silver !important;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: none !important;
  content: attr(data-deselect);
  color: silver !important;
  font-family: "custom-helvetica-medium", "roboto";
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>